import {Platform, SocialPlatform} from '@/types/platforms';

export const SUPPORT_LINK =
  'https://help-popularpays.lightricks.com/hc/en-us/categories/24969753771282-Creator-Experience';

export const SUPPORT_EMAIL = 'popularpays-support@lightricks.com';

export const ERRORS = {
  USER_SUSPENDED: 'USER_SUSPENDED',
};

export const DEPRECATED_NETWORK_IDS = ['tiktok', 'twitter'];

// Query param keys used for social connect error propagation via URL
export const ERROR_MESSAGE_PARAM_KEY = 'message';
export const ERROR_PROVIDER_PARAM_KEY = 'provider';
export const TOAST_PARAM_KEY = 'toast';

/**
 * Maps technical provider identifiers (used by backend/API) to user-friendly platform names (displayed in UI).
 * Used when processing user identities from the API to convert provider names to display-friendly format.
 */
export const providerToPlatformMap: Record<string, SocialPlatform> = {
  instagram: Platform.Instagram,
  tiktok_v2: Platform.TikTok,
  youtube: Platform.YouTube,
  facebook: Platform.Facebook,
  pinterest: Platform.Pinterest,
} as const;

/**
 * Maps user-friendly platform names (used in UI) to technical provider identifiers (needed for API calls).
 * Used when converting from UI platform selections to backend provider identifiers.
 */
export const platformToProviderMap: Record<SocialPlatform, string> = {
  ...Object.entries(providerToPlatformMap).reduce((acc, [key, value]) => {
    acc[value] = key;
    return acc;
  }, {} as Record<SocialPlatform, string>),
} as const;

export default {};
